import React from "react";
import Hero from "../Hero/Hero";
// import Subscribe from "../Subscribe/Subscribe";
// import Testimonials from "../Testomonials/Testimonials";

const Home = ({ handleOrderPopup }) => {
  return (
    <div>
      <Hero handleOrderPopup={handleOrderPopup} />
      {/* <Subscribe />
      <Testimonials /> */}
    </div>
  );
};

export default Home;
